import { Box, Button, TextField, Typography } from "@mui/material";

const RenderArrayFields = ({ data, setData, fields, label }) => {
  const handleChange = (index, key, value) => {
    const updated = [...data];
    updated[index][key] = value;
    setData(updated);
  };

  const addRow = () => {
    setData([...data, fields.reduce((a, c) => ({ ...a, [c]: "" }), {})]);
  };

  const removeRow = (index) => {
    setData(data.filter((_, i) => i !== index));
  };

  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        {label}
      </Typography>

      {data.map((item, index) => (
        <Box key={index} sx={{ border: "1px solid #ddd", p: 2, mt: 1 }}>
          {fields.map((field) => (
            <TextField
              key={field}
              fullWidth
              margin="dense"
              label={field}
              value={item[field]}
              onChange={(e) => handleChange(index, field, e.target.value)}
            />
          ))}

          <Button color="error" size="small" onClick={() => removeRow(index)}>
            Remove
          </Button>
        </Box>
      ))}

      <Button size="small" onClick={addRow}>
        + Add {label}
      </Button>
    </>
  );
};
export default RenderArrayFields;